import { useCriteriaIndexQueryContext } from 'modules/anonymousUserTracking/context/CriteriaIndexQueryContext';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { ActionMenu } from 'ui/actionMenu/ActionMenu';
import { MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Overflow } from 'ui/icons/navigation/Overflow';
import { createActivateOption, createArchiveOption } from 'modules/anonymousUserTracking/utils';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { MODERNIZED_SEGMENTATION_PAGE } from 'modules/segmentation/constants';
import { useCreateViewInSegmentationOption } from 'modules/anonymousUserTracking/hooks/useCreateViewInSegmentationOption';

export const ActionsCell = ({
  criteria,
  setIsArchivalModalOpen,
  setIsToggleActiveModalOpen,
  setActionModalCriteria,
}: {
  criteria: AnonUserCriteria;
  setIsArchivalModalOpen: (open: boolean) => void;
  setIsToggleActiveModalOpen: (open: boolean) => void;
  setActionModalCriteria: (criteria: AnonUserCriteria) => void;
}) => {
  const { maxActiveCriteriaLimitReached } = useCriteriaIndexQueryContext();
  const isModernizedSegmentationPageEnabled = useFeatureFlag(MODERNIZED_SEGMENTATION_PAGE);

  const viewInSegmentationOption = useCreateViewInSegmentationOption({
    criteriaId: criteria.id,
    isModernizedSegmentationPageEnabled,
  });

  return (
    <ActionMenu
      align={MENU_ALIGNMENTS.RIGHT}
      options={[
        ...(!criteria.isArchived
          ? [
              createActivateOption({
                criteria,
                setIsToggleActiveModalOpen,
                setActionModalCriteria,
                maxActiveCriteriaLimitReached,
              }),
            ]
          : []),
        createArchiveOption({ criteria, setIsArchivalModalOpen, setActionModalCriteria }),
        viewInSegmentationOption,
      ]}
    >
      <IconButton variant={BUTTON_VARIANTS.SECONDARY}>
        <Overflow />
      </IconButton>
    </ActionMenu>
  );
};
